export const getFileBlob = async (fileUrl: string): Promise<Blob> => {
    const response = await fetch(fileUrl);
    if (!response.ok) {
        throw new Error('Failed to fetch file blob');
    }
    const blob = await response.blob();
    return blob;
};

/**
 * Save a Blob with a temporary anchor.
 * The object URL stays alive briefly so the browser can start the download.
 */
export const downloadBlob = (blob: Blob, fileName: string) => {
    const objectUrl = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = objectUrl;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.setTimeout(() => URL.revokeObjectURL(objectUrl), 1000);
};

export const prepareBlobFile = async (file: Blob): Promise<Blob> => {
    const pdfBlob = new Blob([file], { type: 'application/pdf' });
    return pdfBlob;
};

export const convertBlobToBase64 = async (file: Blob): Promise<string> => {
    const pdfBlob = new Blob([file], { type: 'application/pdf' });
    const pdfBase64 = await new Promise<string>((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(pdfBlob);
        reader.onload = () => resolve(reader.result as string);
        reader.onerror = (error) => reject(error);
    });

    return pdfBase64;
};
